import noop from '@anm/helpers/noop';
import { axisRight } from 'd3-axis';
import { scaleLinear, scalePoint } from 'd3-scale';
import { line } from 'd3-shape';

import { createSvg } from '../helpers';
import { ChartData } from '../types';

import { AxisProps, DrawProps, LineProps } from './types';

const drawLine = ({ svg, data, width, maxValue, height }: LineProps) => {
  const xScale = scaleLinear()
    .domain([0, data.length - 1])
    .range([0, width]);

  const yScale = scaleLinear()
    .domain([0, maxValue])
    .range([height, 0]);

  const lineFunc = line<ChartData>()
    .x((_: ChartData, index: number) => xScale(index))
    .y(({ value }: ChartData) => yScale(value));

  const path = svg
    .append('path')!
    .datum(data)
    .attr('fill', 'none')
    .attr('class', 'line')
    .attr('d', lineFunc);

  const totalLength = path.node()?.getTotalLength?.() || 0;

  path
    .attr('stroke-dasharray', `${totalLength} ${totalLength}`)
    .attr('stroke-dashoffset', totalLength)
    .attr('stroke', '#30AEF2')
    .transition()
    .duration(4000)
    .attr('stroke-dashoffset', 0);
};

const drawAxises = ({ svg, width, height }: AxisProps) => {
  const x = scalePoint()
    .domain(['0', '20', '40', '60', '80', '100'])
    .range([height, 0]);

  const xAxisGrid = axisRight(x)
    .tickSize(width)
    .tickFormat((v: string) => (v && +v ? `${v}%` : ''));

  svg
    .append('g')
    .attr('class', 'x axis-grid')
    .call(xAxisGrid);
};
``;

export const drawSvg = ({ drawCustomTooltip = noop, ...otherProps }: DrawProps) => {
  const { width, margin } = otherProps;
  const svg = createSvg({
    ...otherProps,
    width: width + margin.right
  });
  const props = { svg, ...otherProps };

  drawLine(props);
  drawAxises(props);
  drawCustomTooltip(props);
};
